import { EuiListGroup, EuiListGroupItem, EuiLoadingContent, EuiText } from "@elastic/eui";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { startCase } from "lodash";
import TripSection from "../shared/TripSection";
import { fetchTripAssignees, assigneesSelector, isLoadingSelector } from "../../slice";
import { mapResourceObjectToArray } from "../../../../utils/jsonApiUtils";

export default function TripAssignees({ tripId }) {
    const dispatch = useDispatch();

    const assignees = mapResourceObjectToArray(useSelector(assigneesSelector()));
    const isLoading = useSelector(isLoadingSelector());

    useEffect(() => {
        if (tripId) {
            dispatch(fetchTripAssignees(tripId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tripId]);

    return (
        <TripSection
            headerTitle={<FormattedMessage id="trip.assignee-section-title" />}
            headerIconType="users"
            size="sm"
            isIconSection
        >
            <div>
                {isLoading ? (
                    <EuiLoadingContent />
                ) : (
                    <EuiListGroup
                        flush
                        wrapText
                        gutterSize="none"
                    >
                        {assignees.map((assignee) => {
                            const label = (
                                <>
                                    <EuiText color="subdued">
                                        {"\u2022"} {""}
                                        {startCase(assignee.userRoles[0])}
                                    </EuiText>
                                    <EuiText
                                        size="s"
                                        style={{ paddingLeft: 12 }}
                                    >
                                        {assignee.email}
                                    </EuiText>
                                </>
                            );
                            return <EuiListGroupItem label={label} />;
                        })}
                    </EuiListGroup>
                )}
            </div>
        </TripSection>
    );
}
